import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import {
  ITaskAcceptRequestBody,
  ITaskDetail,
  ITaskItem,
  ITaskItemRow,
  ITaskPaginatedResponse,
  TaskActionType,
} from '../../../models/Task'
import moment from 'moment'
import { compose } from 'redux'
import { immutableSet } from '../../../utils/immutable'
import { actionTypes } from './actions'
import {
  CANCEL_TAKE_CHARGE_TASK_CALL_STATE,
  CSV_TASK_LIST_IDENTIFIER,
  CSV_TASK_LOADED_IDENTIFIER,
  SELECTED_TASK_IDENTIFIER,
  SELECTED_TASK_TMP_ATTRIBUTES,
  TASK_DETAIL_IDENTIFIER,
  TASK_DETAIL_LOADER_IDENTIFIER,
  TASK_LIST_IDENTIFIER,
  TASK_LIST_LOADER,
  TASK_MAIN_CALL_STATE,
} from './constants'
import emptyState from './emptyState'

const ACTION_HANDLERS = {
  [actionTypes.FETCH_CSV_TASKS_REQUEST]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return immutableSet([CSV_TASK_LOADED_IDENTIFIER], false, state)
  },
  [actionTypes.FETCH_CSV_TASKS_SUCCESS]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    const tempList = action.payload
    const fineResponse: ITaskItem[] = []

    tempList.forEach((task: ITaskItemRow) => {
      const tempRow: ITaskItem = {
        id: task.id,
        internal_id: task.internal_id,
        action: TaskActionType[Number(task.action)],
        application: task.application ? task.application : '',
        entitlement: task.entitlement ? task.entitlement : '',
        createdOn: task.createdOn
          ? moment(task.createdOn).format('DD/MM/YYYY - HH:mm')
          : '',
        beneficiary: task.beneficiary
          ? task.beneficiaryId
            ? `${task.beneficiary} [${task.beneficiaryId}]`
            : task.beneficiary
          : '',
        beneficiary_id: task.beneficiaryId,
        beneficiary_email: task.beneficiaryEmail ? task.beneficiaryEmail : '',
        applicant: task.applicantFullname
          ? task.applicantId
            ? `${task.applicantFullname} [${task.applicantId}]`
            : task.applicantFullname
          : '',
        parentId: task.parentId ? task.parentId : '',
        comment: task.reqComment ? task.reqComment : '',
        enrichment: task.inChargeOf ? task.inChargeOf : '',
        enrichmentCode: task.inChargeOfCode ? task.inChargeOfCode : '',
      }
      fineResponse.push(tempRow)
    })
    return compose(
      immutableSet([CSV_TASK_LOADED_IDENTIFIER], true),
      immutableSet([CSV_TASK_LIST_IDENTIFIER], fineResponse)
    )(state)
  },
  [actionTypes.FETCH_CSV_TASKS_FAILURE]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return compose(
      immutableSet([CSV_TASK_LOADED_IDENTIFIER], true),
      immutableSet([CSV_TASK_LIST_IDENTIFIER], action.payload)
    )(state)
  },

  [actionTypes.SELECT_TASK]: (
    state: any,
    action: { type: string; payload: ITaskItem }
  ) => {
    return immutableSet([SELECTED_TASK_IDENTIFIER], action.payload, state)
  },

  [actionTypes.FETCH_PAGINATED_TASKS_REQUEST]: (state: any, action: any) =>
    immutableSet([TASK_LIST_LOADER], true, state),

  [actionTypes.FETCH_PAGINATED_TASKS_SUCCESS]: (
    state: any,
    action: { type: string; payload: ITaskPaginatedResponse }
  ) => {
    const fineResponse: ITaskItem[] = []

    let { tasks, ...paginationData } = action.payload

    tasks.length > 0 &&
      tasks.forEach((task: ITaskItemRow) => {
        const tempRow: ITaskItem = {
          id: task.id,
          internal_id: task.internal_id,
          action: TaskActionType[Number(task.action)],
          application: task.application ? task.application : '',
          entitlement: task.entitlement ? task.entitlement : '',
          createdOn: task.createdOn
            ? moment(task.createdOn).format('DD/MM/YYYY - HH:mm')
            : '',
          beneficiary: task.beneficiary
            ? task.beneficiaryId
              ? `${task.beneficiary} [${task.beneficiaryId}]`
              : task.beneficiary
            : '',
          beneficiary_id: task.beneficiaryId,
          beneficiary_email: task.beneficiaryEmail ? task.beneficiaryEmail : '',
          applicant: task.applicantFullname
            ? task.applicantId
              ? `${task.applicantFullname} [${task.applicantId}]`
              : task.applicantFullname
            : '',
          parentId: task.parentId ? task.parentId : '',
          comment: task.reqComment ? task.reqComment : '',
          enrichment: task.inChargeOf ? task.inChargeOf : '',
          enrichmentCode: task.inChargeOfCode ? task.inChargeOfCode : '',
        }
        fineResponse.push(tempRow)
      })
    const mappedResponse = { ...paginationData, tasks: fineResponse }
    return compose(
      immutableSet([TASK_LIST_IDENTIFIER], mappedResponse),
      immutableSet([TASK_LIST_LOADER], false)
    )(state)
  },

  [actionTypes.FETCH_PAGINATED_TASKS_FAILURE]: (state: any, error: any) => {
    return compose(
      immutableSet([TASK_LIST_IDENTIFIER], undefined),
      immutableSet([TASK_LIST_LOADER], false)
    )(state)
  },

  [actionTypes.TAKE_CHARGE_TASK_REQUEST]: (state: any) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.PENDING,
      state
    )
  },

  [actionTypes.TAKE_CHARGE_TASK_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.SUCCESS,
      state
    )
  },
  [actionTypes.TAKE_CHARGE_TASK_REQUEST_FAILURE]: (state: any) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.ERROR,
      state
    )
  },

  [actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST]: (state: any) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.PENDING,
      state
    )
  },

  [actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_SUCCESS]: (
    state: any
  ) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.SUCCESS,
      state
    )
  },
  [actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_FAILURE]: (
    state: any
  ) => {
    return immutableSet(
      [CANCEL_TAKE_CHARGE_TASK_CALL_STATE],
      IResponseState.ERROR,
      state
    )
  },

  [actionTypes.APPROVE_TASK_REQUEST]: (
    state: any,
    action: { type: string; body: ITaskAcceptRequestBody[] }
  ) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.PENDING, state)
  },

  [actionTypes.APPROVE_TASK_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.SUCCESS, state)
  },
  [actionTypes.APPROVE_TASK_REQUEST_FAILURE]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.ERROR, state)
  },

  [actionTypes.APPROVE_COMMENT_TASK_REQUEST]: (
    state: any,
    action: { type: string; body: ITaskAcceptRequestBody[] }
  ) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.PENDING, state)
  },
  [actionTypes.APPROVE_COMMENT_TASK_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.SUCCESS, state)
  },
  [actionTypes.APPROVE_COMMENT_TASK_REQUEST_FAILURE]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.ERROR, state)
  },

  [actionTypes.REJECT_TASK_REQUEST]: (
    state: any,
    action: { type: string; body: string[] }
  ) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.PENDING, state)
  },
  [actionTypes.REJECT_TASK_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.SUCCESS, state)
  },
  [actionTypes.REJECT_TASK_REQUEST_FAILURE]: (state: any) => {
    return immutableSet([TASK_MAIN_CALL_STATE], IResponseState.ERROR, state)
  },

  [actionTypes.REJECT_COMMENT_TASK_REQUEST]: (
    state: any,
    payload: { type: string; body: { body: string[]; comment: string } }
  ) => {
    return { ...state }
  },
  [actionTypes.REJECT_COMMENT_TASK_REQUEST_SUCCESS]: (
    state: any,
    payload: any
  ) => {
    return { ...state }
  },
  [actionTypes.REJECT_COMMENT_TASK_REQUEST_FAILURE]: (
    state: any,
    payload: any
  ) => {
    return { ...state }
  },

  [actionTypes.FETCH_TASK_DETAIL]: (
    state: any,
    action: { type: string; payload: any }
  ) => immutableSet([TASK_DETAIL_LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_TASK_DETAIL_SUCCESS]: (
    state: any,
    action: { type: string; payload: ITaskDetail }
  ) => {
    const mappedRes = { ...action.payload }
    mappedRes.taskDetails.map((t) => (t.operationExecuted = false))
    let tmpAttributes: any
    if (mappedRes.taskDetails) {
      mappedRes.taskDetails.forEach((item) => {
        if (item.details) {
          tmpAttributes = { ...tmpAttributes, [item.task_id]: {} }
          if (item.details.fixedAttributes) {
            tmpAttributes = {
              ...tmpAttributes,
              [item.task_id]: {
                ...item.details.fixedAttributes,
              },
            }
          }
          if (item.details.remoteAttributes) {
            tmpAttributes = {
              ...tmpAttributes,
              [item.task_id]: {
                ...item.details.remoteAttributes,
              },
            }
          }
          Object.keys(tmpAttributes[item.task_id]).forEach((attribute: any) => {
            return { ...attribute, isBeingEdited: false }
          })
        }
      })
    }
    return compose(
      immutableSet([TASK_DETAIL_IDENTIFIER], mappedRes),
      immutableSet([SELECTED_TASK_TMP_ATTRIBUTES], tmpAttributes),
      immutableSet([TASK_DETAIL_LOADER_IDENTIFIER], false)
    )(state)
  },

  [actionTypes.FETCH_TASK_DETAIL_FAILURE]: (
    state: any,
    action: { type: string; error: any }
  ) => {
    return compose(
      immutableSet([TASK_DETAIL_IDENTIFIER], action.error),
      immutableSet([SELECTED_TASK_TMP_ATTRIBUTES], null),
      immutableSet([TASK_DETAIL_LOADER_IDENTIFIER], false)
    )(state)
  },
  [actionTypes.RESET_TASK_DETAIL]: (state: any, action: { type: string }) => {
    return compose(
      immutableSet([TASK_DETAIL_IDENTIFIER], null),
      immutableSet([SELECTED_TASK_TMP_ATTRIBUTES], null)
    )(state)
  },

  [actionTypes.UPDATE_TASK_TMP_ATTRIBUTES]: (state: any, action: any) =>
    immutableSet(
      [
        SELECTED_TASK_TMP_ATTRIBUTES,
        action.payload.taskId,
        action.payload.field,
        action.payload.newValue ? 'newValue' : 'isBeingEdited',
      ],
      action.payload.newValue
        ? action.payload.newValue
        : action.payload.isBeingEdited,
      state
    ),
}

export default function communicationReducer(state = emptyState, action: any) {
  if (
    action &&
    action.type === '@@router/LOCATION_CHANGE' &&
    action.payload.location.pathname === '/welcome'
  ) {
    return emptyState
  }
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
